import { get } from './base'

const resourceTypesEndpoint = '/api/v2/resource-types'

export function getResourceTypes() {
  return get(resourceTypesEndpoint)
}
